export {
  default 
} from "./password";
